// extracted by mini-css-extract-plugin
export default {"search":"Search_search__5+v0n","icon":"Search_icon__tdfBb","input":"Search_input__Sg+GP"};